<template>
   <!--Section One-->
      <v-container style="padding-top:5vh; padding-bottom:5vh" id="section2">
        
        <v-row justify="center" align="center" class="center">
          
          <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
            <p
              class="workSans text-h6 text-md-h4 black--text font-weight-medium "
            >
              Online Personal Training with Livefit
            </p>

            <p
              class="text-h5 black--text font-weight-thin"
            >
              To get in shape, you’ll need to be consistent. To be consistent,
              you’ll need help.
            </p>
          </v-col>
        </v-row>

        <v-row justify="center" align="start">
          <v-col 
            cols="12" xs="12" md="6"
            class="my-4"
            v-for="(item, k) in summaryItems"
            :key="k"
          >
            <v-row justify="center" align="start">
              <v-col cols="2">
                <v-img :src="item.icon" width="50" />
              </v-col>
            </v-row>

            <v-row justify="start" align="start">

              <v-col cols="12" class="left">
                <p
                  class="text-subtitle-1 text-md-h6 black--text font-weight-medium"
                >
                  {{item.heading}}
                </p>

                <p
                  class="text-subtitle-1  black--text font-weight-regular"
                >
                  {{ item.body }}
                </p>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    
    <!--Section One-->
</template>


<script>
// @ is an alias to /src

export default {
  name: "Home",
  components: {
    //
  },
  data: () => ({
    summaryItems: [
      {
        icon: "img/icons/featureOne.svg",
        heading: "Lose weight, build strength, and have more energy.",
        body:
          "You tell me your goals. I’ll help you get there. In under one year,you’ll be in better shape than you ever thought possible."
      },
      {
        icon: "img/icons/featureTwo.svg",
        heading: "I'll help you stay accountable.",
        body:
          "I’ll provide you with daily support, guidance and accountability, every step of the way, no matter what life throws at you. We’re in this together."
      },
      {
        icon: "img/icons/featureThree.svg",
        heading: "We'll make living healthy a habit.",
        body:
          "Most people who try to get in shape overload themselves and burn out quickly. Instead, I’ll help you focus on the small practices that lead to big results"
      },
      {
        icon: "img/icons/featureFour.svg",
        heading: "Busy? Let me do the thinking for you.",
        body:
          "You have enough to worry about already. Leave the nutrition and workout details to me while you breathe easy."
      },
      {
        icon: "img/icons/featureSix.svg",
        heading: "Affordable one-on-one coaching.",
        body:
          "Personal coaching is finally affordable. And it just works. Why? Because I am committed to helping you get into the shape you want."
      },
      {
        icon: "img/icons/bulletOne.svg",
        heading: "Easy-to-use online platform",
        body:
          "You’ll start by telling me all about yourself, including your goals, health challenges, and daily routine. From there, I’ll customize your entire program and we’ll start the proven 12-month coaching process."
      },
      {
        icon: "img/icons/bulletOne.svg",
        heading: "Simple nutrition habits and daily check-ins",
        body:
          "Every day, you’ll get a lesson and a nutrition or lifestyle habit to practice. You can either read the daily lesson or listen to it like a podcast. We’ll practice a new nutrition habit every two weeks, with every lesson designed to help you get results."
      },
      {
        icon: "img/icons/bulletOne.svg",
        heading: "Personal coaching and detailed progress checking",
        body:
          "I’ll check in with you frequently to see how you’re doing and to answer any questions you have. The program also tracks everything from your measurements to your habits, so you can see just how much progress you’ve made."
      }
    ],
  }),
  methods: {
    //
  }
};
</script>



<style>
.workSansLight{
  font-family: 'Work Sans', sans-serif !important;font-weight:400;font-style: normal;
}

.workSans{
  font-family: 'Work Sans', sans-serif !important;font-weight:700;font-style: normal;
}

.playFair{
  font-family: 'Playfair Display', serif !important;font-weight:700; font-style:italic;
}


</style>
